// removed by extract-text-webpack-plugin
module.exports = {"root":"home--root--1Zms_M0S organization-home--root--29mpR9MJ","grid-container":"home--grid-container--1QCxxd8r home--grid-container--3c3JLjRI","gridContainer":"home--grid-container--1QCxxd8r home--grid-container--3c3JLjRI","message":"home--message--1HsS4GdE home--message--9FSspPIv"};


//////////////////
// WEBPACK FOOTER
// ./views/refunds/cl-multiplier/home/styles.css
// module id = ./views/refunds/cl-multiplier/home/styles.css
// module chunks = 0